export default "__VITE_ASSET__CGWLZBTh__"